'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';
import MetricBarChart from '../MetricBarChart';

// Sample data: Coverage trend over time
const coverageTrendData = [
  { name: 'Month 1', coverage: 62 },
  { name: 'Month 2', coverage: 65 },
  { name: 'Month 3', coverage: 69 },
  { name: 'Month 4', coverage: 73 },
  { name: 'Month 5', coverage: 78 },
  { name: 'Month 6', coverage: 82 },
];

// Sample data: Coverage by module
const moduleData = [
  { name: 'API Controllers', coverage: 87 },
  { name: 'Business Logic', coverage: 92 },
  { name: 'Services', coverage: 81 },
  { name: 'Data Access', coverage: 76 },
  { name: 'UI Components', coverage: 68 },
  { name: 'Utils', coverage: 73 },
];

export function CodeCoverageTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📈 Coverage Improvement Over Time</h3>
      <MetricLineChart
        data={coverageTrendData}
        lines={[
          { dataKey: 'coverage', name: 'Code Coverage (%)', color: '#E89841' },
        ]}
        xAxisLabel="Month"
        yAxisLabel="Coverage (%)"
        targetLine={80}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing steady improvement from 62% to 82% coverage over 6 months.
        The green dashed line represents the target threshold (80%). Continue enforcement
        on new code to maintain this trajectory.
      </p>
    </div>
  );
}

export function CodeCoverageGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🎯 Current Coverage</h3>
      <MetricGauge
        value={82}
        max={100}
        label="Code Coverage"
        unit="%"
        ranges={[
          { min: 0, max: 60, color: '#EB5757', label: 'Poor' },
          { min: 60, max: 70, color: '#F2C94C', label: 'Fair' },
          { min: 70, max: 80, color: '#4A90E2', label: 'Good' },
          { min: 80, max: 100, color: '#6FCF97', label: 'Excellent' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current coverage of 82% places the codebase in the Excellent category. Focus on
        maintaining this level while ensuring test quality remains high.
      </p>
    </div>
  );
}

export function CodeCoverageByModule() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📊 Coverage by Module</h3>
      <MetricBarChart
        data={moduleData}
        bars={[
          { dataKey: 'coverage', name: 'Coverage (%)', color: '#E89841' },
        ]}
        xAxisLabel="Module"
        yAxisLabel="Coverage (%)"
        targetLine={80}
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Business Logic has the highest coverage (92%) which is excellent for critical code.
        UI Components are below target at 68%—consider increasing coverage for user-facing
        functionality. Data Access layer could also benefit from more integration tests.
      </p>
    </div>
  );
}
